import { es, type MessageKey } from './es';

const messages: Record<MessageKey, string> = es;

/** Texto de la interfaz con parámetros: t('inicio.saludo', { nombre: 'Ana' }). */
export function t(key: MessageKey, params?: Record<string, string | number>): string {
  const text = messages[key];
  return params ? text.replace(/\{(\w+)\}/g, (m, name: string) => (name in params ? String(params[name]) : m)) : text;
}

export type { MessageKey };
